// extracted by mini-css-extract-plugin
export var blue = "_25-f";
export var brand = "_25-b";
export var darkGrey = "_25-e";
export var disabled = "_25-4";
export var disabledSubtle = "_25-5";
export var error = "_25-6";
export var green = "_25-g";
export var grey = "_25-d";
export var icon = "_25-0";
export var inherit = "_25-a";
export var lightGrey = "_25-c";
export var orange = "_25-i";
export var pink = "_25-k";
export var primary = "_25-1";
export var purple = "_25-l";
export var red = "_25-j";
export var secondary = "_25-2";
export var success = "_25-9";
export var tertiary = "_25-3";
export var warning = "_25-7";
export var warningSecondary = "_25-8";
export var white = "_25-m";
export var yellow = "_25-h";